import styled from 'styled-components';

export const DocumentsContainer = styled.div`
    width: 100%;
    padding-top: 16px;
    display: flex;
    flex-direction: column;

    .actions {
        background-color: ${(props) => props.theme.palette.primaryA7};
        margin-top: 24px;
        display: flex;
        width: 100%;
        gap: 16px;
        flex-wrap: wrap;
        border-radius: 12px;

        ${(props) => props.theme.breakpointTo.sm} {
            position: sticky;
            bottom: 24px;
            flex-direction: column-reverse;
            gap: 12px;
            margin-top: auto;
        }

        .button {
            width: calc(50% - 8px);
            transition: all 0.3s, width 0s;
            ${(props) => props.theme.breakpointTo.sm} {
                width: 100%;
            }
        }

        .retake-icon {
            width: 16px;
            height: 16px;
            transform: scale(1.5);
        }

        .secondary {
            background-color: ${(props) => props.theme.palette.primaryA7};
        }

        .full-width-button {
            width: 100%;
        }

        .upload-file-button {
            ${(props) => props.theme.breakpointTo.sm} {
                background-color: ${(props) => props.theme.palette.primaryA7};
            }
        }
    }

    .full-width-button {
        width: 100%;
    }

    .main {
        margin-top: 16px;
        flex: 1;

        ${(props) => props.theme.breakpointTo.sm} {
            margin-top: 0;
            padding-bottom: 24px;
        }
    }

    .requirements-list {
        gap: 8px;
        grid-template-columns: 1fr 1fr 1fr 1fr;

        ${(props) => props.theme.breakpointTo.sm} {
            gap: 12px;
            grid-template-columns: 1fr 1fr;
        }
    }

    .timer {
        margin-bottom: 24px;
    }

    .hidden {
        display: none;
    }

    .select-country-container {
        display: flex;
        flex-direction: column;
        width: 100%;

        .alert-container {
            display: flex;
            gap: 8px;
            background-color: #fbf9e6;
            padding: 8px 16px;
            border-radius: 12px;
            width: 100%;
            margin-top: 8px;
        }

        .country-autocomplete {
            margin-top: 32px;

            ${(props) => props.theme.breakpointTo.sm} {
                margin-top: 20px;
            }
        }
    }

    .success-requirement-card {
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
            width: 200px;
            height: 138px;
        }

        .requirements-text {
            max-width: 200px;
            text-align: center;
        }
    }
`;
